import styled from 'styled-components'

import { Row } from 'components/common'

const Container = styled(Row)`
  display: flex;
  align-items: center;
  height: 100%;
  gap: 4px;
  margin-left: 32px;
`

const NavItem = styled.nav`
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 100%;
  text-align: center;
  transition: transform 0.4s ease-in-out;
`

export { Container, NavItem }
